export const EMAIL_REQUIRED_POLICY = {
  paragraphs: [
    "A verifiable email address is required to use Ahavibes and explore your thoughts with AI.",
    "We may send occasional product-related emails to support your experience. You can opt out of non-essential emails at any time, and you can request account deletion whenever you choose.",
    "AI uses computational resources and energy. We encourage intentional use—use Ahavibes when it helps you reflect, gain clarity, or make a thoughtful decision."
  ]
};
